import React from 'react';
import PropTypes from 'prop-types';
import { getActions, LocaleInitialState, useLocaleReducer, } from './locale-reducer';
export const LocaleState = React.createContext(LocaleInitialState);
export const LocaleActions = React.createContext(getActions(() => undefined));
export const LocaleProvider = ({ children, initialState }) => {
    const [state, dispatch] = useLocaleReducer(initialState);
    const actions = getActions(dispatch);
    return (React.createElement(LocaleActions.Provider, { value: actions },
        React.createElement(LocaleState.Provider, { value: state }, children)));
};
LocaleProvider.propTypes = {
    children: PropTypes.node.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    initialState: PropTypes.object,
};
LocaleProvider.defaultProps = {
    initialState: undefined,
};
